function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_447",
  "data-name": "Path 447",
  d: "M0,0H24V24H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_448",
  "data-name": "Path 448",
  d: "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.011,8.011,0,0,1,12,20Z",
  fill: "#a7afb9"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1125",
  "data-name": "Rectangle 1125",
  width: 2,
  height: 6,
  rx: 1,
  transform: "translate(11 11)",
  fill: "#a7afb9"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_41",
  "data-name": "Ellipse 41",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(11 7)",
  fill: "#a7afb9"
});

var SvgInfoLargeDisabled = function SvgInfoLargeDisabled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_Info_disabled",
    "data-name": "Icon - Info_disabled",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoLargeDisabled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-large-disabled.9293e344.svg";
export { ForwardRef as ReactComponent };